import { gql } from '@apollo/client'

import { CUSTOMER_ADDRESS_FRAGMENT } from '../../fragments/customer/address'

export const GET_CURRENT_CUSTOMER_ADDRESSES = gql`
  query CurrentCustomerAddresses {
    currentCustomer {
      id
      primaryAddress {
        id
      }
      addresses {
        ...CustomerAddress
      }
    }
  }
  ${CUSTOMER_ADDRESS_FRAGMENT}
`
